import React, { useState, useEffect, useContext } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../pages/Cigna/notification.css';
import alertcircle from "../assets/images/icons/alert-circle.svg";
import membershield from "../assets/images/Member-Shield.svg";
import calander from "../assets/images/icons/calendar-billing.svg";
import "react-datepicker/dist/react-datepicker.css";
import '../assets/css/feather.css';
import '../assets/css/Style.css';
import { getApiService, postApiService } from "../services/ApiService";
import { GetPayLoad } from '../services/PayLoadStorage';
import {LanguageContext} from "../contexts/LanguageContext";
import parse from 'html-react-parser';
import {toast} from 'react-toastify';
import Cookies from 'js-cookie';

const MemberPreference = () => {
 
    const [memberPreference , setMemberPreference] = useState([]);
    const [commonContent, setCommonContent] = useState('');
    const { pageContent } = useContext(LanguageContext);
    const [memPrefContent, setMemPrefContent] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    const date = new Date();
    const currentDateFormat = date.toLocaleDateString("en-US", {
        month: "short",    
        day: "2-digit",    
        year: "numeric"    
      });

    const Payload = GetPayLoad('PayLoad');
    useEffect(() => {

        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);

        if (pageContent?.settings) {
            setMemPrefContent(pageContent.settings);
        }
    }, [pageContent]);
    
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const lang = Cookies.get('lang') || 'eng'; // Default to 'eng' if not set
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region
    };
    
    const [readOnlyMode, setReadOnlyMode] = useState(false);

    useEffect(() => {
        const enableMemPreference = Cookies.get('enableMemPreference') || 'false'; // Default to 'false' if not set
        // Check if enableMemPreference is set to true    
        if(enableMemPreference === 'true' || enableMemPreference === true) {   
            callMemberPreference();
        }
    }, [lang]);
    
    const callMemberPreference = () => {
        const targetCaseUrl = process.env.REACT_APP_API_GET_MEMBER_PREFERENCE_ENDPOINT;
        getApiService(baseUrl, targetCaseUrl, {case_num: Payload?.case_num, cim: Payload?.cim, carrier: Payload?.owning_carrier, site_cd: Payload?.site_cd,  lang: lang }, headers)
            .then((response) => {
                
                if (response?.data?.statusCode !== 200) {
                   
                }else{
                    const result = response.data.data;
                    setMemberPreference(result?.preferenceSettings);
                    setCommonContent(result?.commonContent);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                console.error('Error fetching member preference:', error);
                setIsLoading(false); // Stop loading state on error
            });
    };
      
    const [isChecked, setIsChecked] = useState({}); // Toggle state for checkboxes
    const [isDisabled, setIsDisabled] = useState(false); // State to manage checkbox disable state
    // Initialize isChecked state with memberPreference data
    useEffect(() => {
        const initialCheckedState = memberPreference?.reduce((acc, item) => {
            acc[item.preferenceType.toLowerCase()] = item?.enabled;
            return acc;
        }, {});
        setIsChecked(initialCheckedState);
    }, [memberPreference]);

    const handleToggle = (name, checked) => {
        // Update the isChecked state for the current checkbox
        setIsChecked(prev => ({
            ...prev,
            [name]: checked  // set true/false explicitly for this checkbox
          }));
    };

    // State to manage correspondence settings checkboxes
    const [checkedItems, setCheckedItems] = useState({});
    const [categoryVal, setCategoryVal] = useState({}); // State to manage category value

    // Initialize checkedItems state with memberPreference data
    useEffect(() => {
        const initialCheckedItems = memberPreference?.reduce((acc, item) => {
            item.correspondenceSettings.forEach((correspondence, idx) => {
                acc[`${item.preferenceType.toLowerCase()}-${idx}`] = correspondence?.preferenceStatus || false; // Initialize with enabled state
            });
            return acc;
        }, {});
        setCheckedItems(initialCheckedItems);

        const initialCategoryVal = memberPreference?.reduce((acc, item) => {
            item.correspondenceSettings.forEach((correspondence, idx) => {
                const checkedString = correspondence?.preferenceStatus === true ? 'Y' : 'N'; // Convert preferenceStatus to string
                acc[`${item.preferenceType.toLowerCase()}-${idx}`] = checkedString+'-'+correspondence?.correspondenceCategory || ''; // Initialize with category value
            });
            return acc;
        }, {});
        setCategoryVal(initialCategoryVal);

    }, [memberPreference]);

    // Handle change event
    const handleChange = (event) => {
        const { name, checked } = event.target;
        setCheckedItems((prevState) => ({
            ...prevState,
            [name]: checked, // Toggle the checkbox value
        }));
        // Update categoryVal based on the checkbox state
        const checkedString = checked === true ? 'Y' : 'N'; // Convert checked to string
        const [type, index] = name.split('-');
        const correspondenceCategory = memberPreference.find(item => item.preferenceType.toLowerCase() === type)?.correspondenceSettings[index]?.correspondenceCategory || '';
        if(checked){
            setCategoryVal((prevState) => ({
                ...prevState,
                [name]: checkedString+'-'+correspondenceCategory, // Set the category value
            }));
        }else{
            setCategoryVal((prevState) => ({
                ...prevState,
                [name]: checkedString+'-'+correspondenceCategory, // Set the category value
            }));
        }
    };

    // Handle signature checkbox change and save button enable/disable logic
    const [signatureChecked, setSignatureChecked] = useState(false);
    const handleSignatureChange = (event) => {
        const { checked } = event.target;
        setSignatureChecked(checked);
    }

    //Validate Text Box after typed
    const [contactError, setContactError] = useState(true);
    const [contactErrorType, setContactErrorType] = useState(''); // Track the type of contact error
    
    const validateContactDetails = (value, type) => {

        if (type === 'email') {
            // Validate email format
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setContactError(emailPattern.test(value));
            setContactErrorType(type);
            return emailPattern.test(value);

        } else if (type === 'text' ||  type === 'voice') {
            // Validate phone number format (10 digits)
            const phonePattern = /^\d{10}$/;
            setContactError(phonePattern.test(value));
            setContactErrorType(type);
            return phonePattern.test(value);

        }
        return true;
    };

    // Validate form before submission
    const validate = () => {

        const isAnyChecked = Object.values(isChecked).some(value => value === true);
        if (!isAnyChecked) {
            toast.error(memPrefContent?.member_preference_empty_pref);
            return false;
        }
        
        // Check if at least one correspondence is selected for each checked preference
        for(const key in isChecked){
            if (isChecked[key]) {
                const hasMatch = Object.entries(checkedItems)
                  .some(([secKey, value]) => secKey.startsWith(`${key}-`) && value === true);
          
                if (!hasMatch) {
                  toast.error(`Please select at least one correspondence for ${key} preference.`);  
                  return false;
                }
            }
        }

        if(!contactError) {
            
            if(contactErrorType === 'email') {
                toast.error(memPrefContent?.member_preference_email_error);
            }

            if(contactErrorType === 'text'){
                toast.error(memPrefContent?.member_preference_text_error);
            }

            if(contactErrorType === 'voice'){
                toast.error(memPrefContent?.member_preference_voice_error);
            }
           
            return false;
        }

        return true; // Allow form submission if validation passes
    }
    
    const [contactDetails, setContactDetails] = useState({
        primary: '',
        secondary: ''
    });

    // Initialize contact details based on memberPreference data
    useEffect(() => {   
        const initialContactDetails = memberPreference?.reduce((acc, item) => {
            if (item.preferenceType === 'TEXT' || item.preferenceType === 'VOICE') {
                acc[`primary-${item.preferenceType.toLowerCase()}`] = item.contactDetails.replace(/[^0-9]/g, '') || '';
                acc[`secondary-${item.preferenceType.toLowerCase()}`] = item.secondaryContactDetails.replace(/[^0-9]/g, '') || '';
            }
            if(item.preferenceType === 'EMAIL') {
                acc[`primary-${item.preferenceType.toLowerCase()}`] = item.contactDetails || '';
            }
            return acc;
        }, {});
        setContactDetails(initialContactDetails);
    }, [memberPreference]);

    const handleContactChange = (e) => {
        const { name, value } = e.target;
        setContactDetails(prevState => ({
            ...prevState,   
            [name]: value
        }));
        
    }
        
    // Handle form submission
    const handelSubmit = (e) => {
        e.preventDefault();
        if (!validate()) {
            return; // Stop submission if validation fails
        }

        // Prepare data for submission
        const formData = {
            case_num: Payload?.case_num, 
            cim: Payload?.cim, 
            carrier: Payload?.owning_carrier,
            site_cd: Payload?.site_cd,
            prefType: isChecked,
            categoryVal: categoryVal,
            contactDetails: contactDetails
        };

        const targetUrl = process.env.REACT_APP_API_ADD_MEMBER_PREFERENCE_ENDPOINT;

        postApiService(baseUrl, targetUrl, formData, headers)
        .then((response) => {
            const result = response.data;
            if (result?.statusCode === 200 && result?.data?.status === 'SUCCESS') {
                toast.success(memPrefContent?.member_preference_add_pref_success);
                callMemberPreference(); // Refresh member preference data
                setSignatureChecked(false); // Reset signature checkbox

            } else {
                toast.error(memberPreference?.member_preference_add_pref_failure);
            }
        })
        .catch((error) => {
            toast.error(memberPreference?.member_preference_add_pref_failure);
        });

    }
    
    // Handle opening edit preference modal
    const [editPreferenceType, setEditPreferenceType] = useState('');
    const handleOpenEdit = (type) => {
        setEditPreferenceType(type);
    }
    
    const handleCancelEdit = (e) => {
        e.preventDefault();
        setEditPreferenceType('');
        // Reset contact details to initial state
        const initialContactDetails = memberPreference?.reduce((acc, item) => {
            if (item.preferenceType === 'TEXT' || item.preferenceType === 'VOICE') {
                acc[`primary-${item.preferenceType.toLowerCase()}`] = item.contactDetails.replace(/[^0-9]/g, '') || '';
                acc[`secondary-${item.preferenceType.toLowerCase()}`] = item.secondaryContactDetails.replace(/[^0-9]/g, '') || '';
            }
            if(item.preferenceType === 'EMAIL') {
                acc[`primary-${item.preferenceType.toLowerCase()}`] = item.contactDetails || '';
            }
            return acc;
        }, {});
        setContactDetails(initialContactDetails);
        setContactError(true); // Reset contact error state
        setContactErrorType(''); // Reset contact error type
    }

    return (
        <div>
        {!isLoading && memberPreference ? (        
        <div className="tab-pane fade show" id="nav-Notification" role="tabpanel" aria-labelledby="nav-Notification-tab">
            <div className="members-pre">
                <div className="border-tab">
                    <div className="members-2FA mb-3 rounded">
                        <div className="col-12 d-flex">
                            <div className="col-9 d-flex">
                                <div className="col-1">
                                    <img src={membershield} alt="membershield" />
                                </div>
                                <div className="col-10 ms-2">
                                    <h5 className="mt-2 electronic_headding">
                                    {commonContent?.prefSelectionMsg}
                                    <br />
                                    <span className="mt-1 d-block election ">
                                    {commonContent?.prefChangeSuggestions}
                                    </span>
                                    </h5>
                                    <p className="mt-1">
                                    {commonContent?.prefSuggestions}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form name="memberPreferenceForm" className="needs-validation" noValidate>
                    <fieldset disabled={readOnlyMode}>   
                    {
                    memberPreference.map((item, index) => (
                        <div className="border-tab">
                            <div className="col-12 d-flex mb-2">
                                <div className="col-xl-11 mt-2">
                                    <h5>{item?.preferenceDescription}</h5>
                                </div>
                                <div className="col-xl-1 text-start me-3">
                                    <div className="form-check form-switch">
                                        <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexSwitchCheckChecked"
                                        checked={!!isChecked[item?.preferenceType.toLowerCase()]}
                                        name={item?.preferenceType.toLowerCase()}
                                        onChange={(e) => handleToggle(item?.preferenceType.toLowerCase(), e.target.checked)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <p className="d-block mb-1">
                                    {item?.contactDescription}{' '} 
                                    {editPreferenceType !== 'primary-'+item?.preferenceType && 
                                    <span className="text-decoration-underline">
                                    { item?.contactDetails }
                                    <i className="fe fe-edit-3 ms-1 fe-15 text-decoration-none" 
                                    style={{cursor:'pointer', margin: '10px'}}
                                    onClick={() => handleOpenEdit('primary-'+item?.preferenceType)}></i>
                                    </span>
                                    }
                                    {
                                    editPreferenceType === 'primary-'+item?.preferenceType && 
                                    <div style={{display: 'inline-flex', gap:'8px', marginLeft:'10px'}}>
                                    <input 
                                    type="text" 
                                    onChange={handleContactChange}
                                    name={`primary-${item?.preferenceType.toLowerCase()}`} 
                                    className="form-control mt-2 mb-2"
                                    maxLength={item?.preferenceType === 'EMAIL' ? 50 : 10}
                                    style={item?.preferenceType === 'EMAIL' ? {width: '250px'} : {width: '135px'}}
                                    onBlur={(e) => {validateContactDetails(e.target.value, item?.preferenceType.toLowerCase()) ? e.target.classList.remove('is-invalid') : e.target.classList.add('is-invalid')}}  
                                    value={contactDetails[`primary-${item?.preferenceType.toLowerCase()}`] || ''}
                                    />
                                    <input 
                                    type="button" 
                                    value="Cancel" 
                                    className="btn btn-primary mt-2 mb-2" 
                                    onClick={handleCancelEdit}
                                    name={`primary-${item?.preferenceType.toLowerCase()}`}
                                    />
                                    </div>
                                    }

                                    {(item?.preferenceType === 'TEXT' || item?.preferenceType === 'VOICE') ? (
                                        <>
                                        {memPrefContent?.member_preference_secondary_phone_label}{ ' '}
                                        { 
                                        editPreferenceType !== 'secondary-'+item?.preferenceType &&
                                        <span className="text-decoration-underline">
                                        {item?.secondaryContactDetails || 'N/A'}
                                        <i className="fe fe-edit-3 ms-1 fe-15 text-decoration-none" 
                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                        onClick={() => handleOpenEdit('secondary-'+item?.preferenceType)}></i>
                                        </span>
                                        }
                                        {
                                        editPreferenceType === 'secondary-'+item?.preferenceType &&
                                        <div style={{display: 'inline-flex', gap:'8px', marginLeft:'10px'}}>
                                            <input 
                                            type="text" 
                                            onChange={handleContactChange}
                                            name={`secondary-${item?.preferenceType.toLowerCase()}`} 
                                            className="form-control mt-2 mb-2"
                                            maxLength={10}
                                            onBlur={(e) => {validateContactDetails(e.target.value, item?.preferenceType.toLowerCase()) ? e.target.classList.remove('is-invalid') : e.target.classList.add('is-invalid')}}
                                            value={contactDetails[`secondary-${item?.preferenceType.toLowerCase()}`] || ''}   
                                            />
                                            <input 
                                            type="button" 
                                            value="Cancel" 
                                            className="btn btn-primary mt-2 mb-2" 
                                            onClick={handleCancelEdit}
                                            name={`secondary-${item?.preferenceType.toLowerCase()}`}
                                            />
                                        </div>
                                        }
                                       
                                        </>
                                    ) : null}
                                </p>
                                {
                                    item?.preferenceType === 'TEXT' &&
                                    <p className="mt-2 mb-2">
                                        {commonContent?.textMobileHint}
                                    </p>
                                }
                                {
                                    item?.preferenceType === 'VOICE' &&
                                    <p className="mt-2 mb-2">
                                        {commonContent?.voiceMobileHint}
                                    </p>
                                }
                                <p className="mt-1 mb-1">{item?.prefTypeDescription}:</p>
                                {
                                    item?.correspondenceSettings.map((correspondence, idx) => (
                                    <div key={idx} className="d-flex mt-3 mb-1 form-checkbox">
                                        <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`${item?.preferenceType.toLowerCase()}-${idx}`}
                                        name={`${item?.preferenceType.toLowerCase()}-${idx}`}
                                        checked={checkedItems[`${item?.preferenceType.toLowerCase()}-${idx}`] || false}
                                        value={categoryVal[`${item?.preferenceType.toLowerCase()}-${idx}`] || ''}
                                        onChange={handleChange}
                                        disabled={!isChecked[item?.preferenceType.toLowerCase()] || isDisabled}
                                        />
                                        <label className="form-check-label form-label grey-heading ms-2 mt-1" htmlFor={correspondence?.id}>
                                        {correspondence?.correspondenceDescription}
                                        </label>
                                    </div>
                                    ))
                                }
                            </div>
                            <div className="mt-3">
                                <p>
                                <img src={alertcircle} className="me-1" alt="Alert" />
                                {item?.prefNotes}
                                </p>
                            </div>
                        </div>
                        ))
                    }
                    <div className="col-12">
                        <div className="mt-3">
                            <div className="col-12 d-flex">
                                <div className="col-10">
                                    <div className="mt-1 mb-1 form-checkbox  e-signature">
                                        <input 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        value="1"
                                        id="flexCheckDefault11"
                                        name= "e-signature"
                                        onChange={handleSignatureChange}
                                        checked={signatureChecked}
                                        />
                                        <label
                                        className="form-check-label form-label grey-heading ms-2 mt-1"
                                        for="flexCheckDefault11">
                                        {commonContent?.eSignConfirm}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="mb-3 radio datepicks">
                                        <div className="form-floating mb-2 position-relative" style={{ position: "relative" }}>
                                            <input
                                            id="datepicker"
                                            type="text"
                                            className="form-login-control"
                                            disabled={true}
                                            style={{width: '85%', fontWeight:'bold'}}
                                            value={currentDateFormat}
                                            />
                                            <span className="input-group-append">
                                                <img
                                                src={calander}
                                                className="me-2 position-absolute"
                                                alt="Calendar"
                                                width={20}
                                                height={20}
                                                style={{ position: 'absolute', top: '12px', right: '28px', }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3">
                            {parse(String(commonContent?.eSignDisclaimer))}
                        </div>
                    </div>
                    {!readOnlyMode && (
                    <div className="text-end mt-4 mb-4">
                        <button className="btn btn-secondary btn-lg" 
                        type="button"
                        data-bs-dismiss="modal" id="liveToastBtn"
                        disabled={!signatureChecked}
                        onClick={handelSubmit}
                        >
                        {memPrefContent?.member_preference_submit_btn_label}
                        </button>
                    </div>
                    )}
                    </fieldset>
                    </form>
                </div>
            </div>
        </div>
        ) : (
        <div className="text-center mt-5">
            <p>{memPrefContent?.member_preference_service_error}</p>
            <br/>
        </div>
        )}
        </div>
    );
}
export default MemberPreference;
